
import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  Table,
} from "reactstrap";
import { fetchSchools } from "slices/schoolSlice";
import { schoolSelector } from "slices/schoolSlice";

import Api from "services/api"
import AddSchool from "components/school/AddSchool";
import { removeSchool } from "slices/schoolSlice";
import toast from "react-hot-toast";
import ConfirmationModal from "components/common/ConfirmationMessage";
import { ListLayout } from "components/common/ListLayout";
import { SortButtons } from "components/common/SortButtons";
import { CustomSwitch } from "components/common/Switch";
import { changeStatus } from "slices/schoolSlice";
import { removeMultipleSchools } from "slices/schoolSlice";
import TableHeaderItem from "components/common/ListLayout/TableHeaderItem";
import { convertTimeToUTC } from "helpers/convertTimeToUTC";
import { usePermissions } from "layouts/Admin";

const apiService = new Api();

function SchoolList() {
  const dispatch = useDispatch()
  const { checkPermission } = usePermissions();
  const { schools, last_page: totalPages, loader, total, current_page, per_page: pageLength } = useSelector(schoolSelector);
  const [addForm, setAddForm] = React.useState({
    show: false,
    item: {}

  });
  const refAddutton = React.useRef(null);

  const [selectedItems, setSelectedItems] = React.useState([]);
  const [selectAll, setSelectAll] = React.useState(false);
  const [deleteModal, setDeleteModal] = React.useState(false);
  const [selectedValue, setSelectedValue] = React.useState([10])
  const [currentPage, setCurrentPage] = React.useState(1);
  const [searchTerm, setSearchTerm] = React.useState("");
  const [sortConfig, setSortConfig] = React.useState({
    sortBy: 'name',
    sortDirection: 'asc',
  });



  React.useEffect(() => {
    dispatch(fetchSchools(1))
  }, [])

  const handleAddSchoolPopUp = (item) => {
    setAddForm({
      show: true,
      item,
    });
  };

const submitCallback = async (status, message) => {
  if (status) {
    toast.success(message, { className: "successToast" });

    setSelectedItems([]);
    setSelectAll(false);
       await dispatch(fetchSchools(currentPage, { sortBy: sortConfig.sortBy, sortDirection: sortConfig.sortDirection, search: searchTerm }));

    // ✅ Reload schools and update table
    const updatedSchools = await dispatch(fetchSchools(1, {}, true, true)); // fetch latest schools
    dispatch({ type: 'school/setSchools', payload: updatedSchools }); // set table data

    hideConfirmDialog();
  } else {
    toast.error(message, { className: "errorToast" });
  }
};



  const showConfirmDialog = () => {
    setDeleteModal(true);
    return
  };
  const hideConfirmDialog = () => {
    setDeleteModal(false);
  }
  const handleRemoveItems = async () => {
  await dispatch(removeMultipleSchools({ ids: selectedItems }, submitCallback));
  await dispatch(fetchSchools(currentPage, { sortBy: sortConfig.sortBy, sortDirection: sortConfig.sortDirection, search: searchTerm }));
};

  const handleChange = (e) => {
    // handle form change
    const id = e.target.dataset.value
    setSelectedItems(
      selectedItems.includes(id) ?
        selectedItems.filter((item) => item != id) :
        [...selectedItems, id]
    )
  };
  const handleToggleSelectAll = () => {
    if (selectAll) {
      setSelectedItems([])
      setSelectAll(false)
      return
    }
    setSelectAll(true)
    setSelectedItems(schools?.map((school) => school.id.toString()))


  }

  const handlePageChange = React.useCallback((page) => {
    setCurrentPage(page);
    dispatch(fetchSchools(page));
  }, [])

  const handleClose = () => {
    refAddutton.current.click(); setAddForm({ show: false })
  };

  const handleSelect = (value) => {
    setSelectedValue(value)

  }


  //#region TABLE HEAD 

  const renderTableHeader = React.useCallback(() => {


   const callBack = (dir, sortBy) => {
    setSortConfig({ sortBy, sortDirection: dir });
    setCurrentPage(1);   // reset to first page on sort
    dispatch(fetchSchools(1, { sortBy: sortBy, sortDirection: dir, search: searchTerm }));
}

    return (
      <tr>
        <th className="col-2">
          <div className="row_check">
            <span>#</span>
            {checkPermission('Delete Cities') &&
              <label className="custom-checkbox checkbox"><input type="checkbox" name="select-all" checked={selectAll} onChange={handleToggleSelectAll} /><span className="checkmark"></span></label>
            }
          </div>
        </th>
        <th className="col-5">
          <TableHeaderItem
            title="School Name"
            sortBy="name"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>

        <th className="col-3">
          <TableHeaderItem
            title="Zone"
            sortBy="zone"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        {/* <th className="col-3">
          <TableHeaderItem
            title="Creation Date"
            sortBy="created_at"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th> */}
        {/* {checkPermission('Status Cities') &&
          <th >Status</th>
        } */}
        {checkPermission('Edit Cities') &&
          <th  className="col-2">Actions</th>
        }
      </tr>
    )
  }, [selectAll, searchTerm, sortConfig, currentPage, selectedItems]);

  //#endregion


  //#region TABLE BODY

 const renderTableContent = React.useCallback(() => {
  return (
    schools?.map((school, index) => (
      <SchoolItem
        key={school.id} // ← add this
        school={school}
        index={index}
        selectedItems={selectedItems}
        handleChange={handleChange}
        handleAddPopUp={handleAddSchoolPopUp}
        current_page={current_page}
        pageLength={pageLength}
        checkPermission={checkPermission}
      />
    ))
  )
}, [schools, selectedItems]);

  //#endregion


  return (
    <ListLayout
      heading="School"
      time={true}
      title=""
      buttonTitle="Add School"
      renderTableHeader={renderTableHeader}
      renderTableContent={renderTableContent}
      addButtonDisabled={!checkPermission('Create Cities')}
      totalPages={totalPages}
      fetchList={fetchSchools}
      selectedItems={selectedItems}
      handleRemoveItems={handleRemoveItems}
      renderAddForm={(callback) => <AddSchool item={addForm.item} show={addForm.show} onClose={handleClose} callback={callback} statusPerm={checkPermission('Status Cities')} />}
      refAddutton={refAddutton}
      addForm={addForm}
      showConfirmDialog={showConfirmDialog}
      handleAddPopUp={handleAddSchoolPopUp}
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
      loader={loader}
      searchPlaceholder="Search School ..."
      noOfItems={total}

    >

      {deleteModal && <ConfirmationModal onClose={hideConfirmDialog} isOpen={deleteModal} onConfirm={handleRemoveItems} />}
    </ListLayout>
  )

}


const SchoolItem = ({
  school, index, selectedItems, handleChange, handleAddPopUp, current_page, pageLength, checkPermission
}) => {
  const dispatch = useDispatch();
  const [status, setStatus] = React.useState(school?.status == "active" ? 1 : 0 || 0);

  const handleStatusChange = (id, s) => {
    setStatus(s ? 1 : 0)
    dispatch(changeStatus(id, { status: s ? 1 : 0 }));

  }

  React.useEffect(() => {
    setStatus(school?.status == "active" ? 1 : 0 || 0)

  }, [school])

  const getBackgroundStyle = (status) => {
    return status === 0 ? { background: '#f4f4f4' } : {};
  };
  const serial = useMemo(() => {
    return index + 1 + (current_page - 1) * pageLength;
  }, [current_page, pageLength]);

  console.log(school, "school")
  return (
    <tr>
      <td style={getBackgroundStyle()}>
        <div className="row_check">
          <span>{serial}</span>
          {checkPermission('Delete Cities') &&
            <label className="custom-checkbox checkbox">
              <input type="checkbox" name="select-all" data-value={school?.id} checked={selectedItems.includes(school?.id.toString())} onChange={handleChange} />
              <span className="checkmark"></span>
            </label>
          }
        </div>
      </td>
      <td style={getBackgroundStyle()}>
        {school?.name}
      </td>
      <td style={getBackgroundStyle()}>
        {school?.zone?.name}
      </td>
      {checkPermission('Edit Cities') &&
        <td style={getBackgroundStyle()}>
          <button className="table_edit" data-bs-toggle="modal" data-bs-target="#exampleModal" onClick={() => handleAddPopUp({ ...school, status })}>Edit</button>
        </td>
      }
    </tr>
  )
}


export default SchoolList;
